/* Faubourg & Fils — mega-menu volet 2 niveaux : active le panneau au survol. */
(function () {
  function init(root) {
    var items = root.querySelectorAll('.ffm__nav .ffm__item');
    var panels = root.querySelectorAll('.ffm__stage .ffm__panel');
    if (!items.length || !panels.length) return;
    function activate(i) {
      items.forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-ffm-i') === i); });
      panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-ffm-p') === i); });
    }
    items.forEach(function (it) {
      var i = it.getAttribute('data-ffm-i');
      it.addEventListener('mouseenter', function () { activate(i); });
      it.addEventListener('focus', function () { activate(i); });
    });
  }
  function boot() {
    document.querySelectorAll('.ffm[data-ffm]').forEach(function (el) {
      if (el.__ffmReady) return; el.__ffmReady = true; init(el);
    });
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  // le header peut etre re-rendu par l'editeur de theme
  document.addEventListener('shopify:section:load', boot);
})();
